module.exports = __webpack_public_path__ + "img/tile-min2.ab5be771.jpg";